import React, {useCallback, useEffect, useReducer} from "react"

import { DialogContent, Dialog, Divider, DialogTitle, Button, Box, IconButton, Tooltip,  Checkbox } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'

import {
    DataGridPro,
    ptBR,
} from '@mui/x-data-grid-pro';

import { ptBR as corePtBR } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { lockedReducer } from "../../../utils/defaultReducer";
import Loading from "../../Loading";
import api from "../../../api";
import { getSession } from "../../../auth";
import useNotification from "../../Notification";

import GoogleIcon from '@mui/icons-material/Google';
import WindowIcon from '@mui/icons-material/Window';
import KwikIcon from "../../../utils/kwikicon";
import DeleteIcon from '@mui/icons-material/Delete';
import { distributedCalendar } from "../DistributedCalendar";
import ConfirmationDialogCaptcha from "../../Dialogs/ConfimationDialogCaptcha";

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);


const SelectIcons = {
    'KWIK': {icon: <KwikIcon />, text: 'Kwik'},
    'MICROSOFT_CALENDAR': {icon: <WindowIcon />, text: 'Microsoft'},
    'GOOGLE_CALENDAR': {icon: <GoogleIcon />, text: 'Google'}
}

const VerAgendas = ({handleClose}) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        loading: false,
        delete: null
    })

    useEffect(()=>{
        const initialize = async () => {
        setState({loading: true})
        setState({rows: await distributedCalendar.get_distributed_calendar(), loading: false})
        }
        initialize()
    }, [])

    const deleteCalendar = useCallback( async()=>{
        setState({loading: true})
        if (await distributedCalendar.delete_calendar(state.delete))
            setState({rows: await distributedCalendar.get_distributed_calendar(), delete: null})
        setState({loading: false})
    }, [state.delete])

    const getColumns = useCallback(() => {
        const columns = []

        const user = String(getSession().id)

        columns.push({ field: 'user', headerName: 'Usuário', flex: 1, renderCell:({value, row}) => <Box sx={{color: row.color}}>{value}</Box> })
        columns.push({ field: 'email', headerName: 'Email', flex: 1, renderCell:({value, row}) => <Box sx={{color: row.color}}>{value}</Box> })
        columns.push({ field: 'provider', headerName: 'Provedor', flex: 1, renderCell: ({value, row}) => {
            const item = SelectIcons[value]
            if (!item) return (<></>)
            return (
            <Tooltip title={item.text}>
                <Box sx={{color: row.color}}>
                    {item.icon}
                </Box>
            </Tooltip>
        )} })
        columns.push({ field: 'actions', headerName: 'Ações', width: 120, renderCell: ({row, api}) => {
            return (
                <>
                    <Checkbox 
                        sx={{color: `${row.color} !important`}} 
                        checked={!row.hide} 
                        onChange={() => {
                            const updated = distributedCalendar.toggle_calendar(row); 
                            api.updateRows([updated])
                    }}/>
                    {(row.owner === user  && row.provider !== 'KWIK') &&
                        <Tooltip title='Excluir Calendário'>
                            <IconButton 
                                className='action-button delete'
                                onClick={() => setState({delete: row})}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            )
        } })

        return columns
    }, [])

  return (
    <>
    <Loading loading={state.loading}/>
        {state.delete && 
            <ConfirmationDialogCaptcha 
                open={true}
                    title="Confirmação"
                    description={
                        <>
                            <Box>
                                Concorda em excluir o calendário do email {state.delete.email}?
                            </Box>
                            <Box>
                                Para confirmar a ação, digite: <span style={{ 'fontWeight': 'bold' }}>remover</span> no campo abaixo.
                            </Box>
                            <br></br>
                        </>
                    }
                    handleClose={() => { setState({ delete: null }) }}
                    handleSubmit={deleteCalendar}
                    captcha={'remover'}
            />
        }
        <Dialog
            open={true}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }} className={'group-flexbox'}>
                Ver Agendas
                <Box>
                    <Button sx={{color:'black'}} onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/criando-eventos-na-agenda-e-automatizando-notificacoes-G0Rn78oIZL", "_blank")}>FAQ</Button>
                    <Button sx={{ 'minWidth': '2rem', 'padding': '0', color:'black' }} onClick={async ()=>{
                        await distributedCalendar.reload_calendar()
                        handleClose()
                    }} ><CloseIcon /></Button>
                </Box>
            </DialogTitle>
            <Divider />
            <DialogContent className='content-dialog-rows'>
                <Box sx={{ width: '100%', height: '520px' }}>
                    <ThemeProvider theme={theme}>
                        <DataGridPro
                            columns={getColumns()}
                            rows={state.rows}
                            disableSelectionOnClick
                            density={'compact'}
                            hideFooter={true}                           
                        />
                    </ThemeProvider>
                </Box>
            </DialogContent>
        </Dialog>
    </>
  )
}

export default VerAgendas